<template>
  <div
    :style="
      $vuetify.breakpoint.mdAndUp ? 'margin-top: 75px' : 'margin-top: 10px'
    "
  >
    <errorDialog :mainColor="mainColor" v-model="error"></errorDialog>

    <v-dialog v-model="waitDialog" width="300">
      <v-card color="white">
        <v-card-title
          class="headline"
          primary-title
          :style="{ color: mainColor }"
        >
          <v-layout justify-center align-content-center>Please Wait</v-layout>
        </v-card-title>
      </v-card>
    </v-dialog>

    <div v-if="displayLPBQuestion">
      <v-layout justify-center align-content-center>
        <v-flex xs8 v-if="$vuetify.breakpoint.mdAndUp">
          <v-card>
            <v-toolbar :color="mainColor" dark>
              <v-card-title class="headline" color="white"
                >Welcome!</v-card-title
              >
            </v-toolbar>
            <v-form style="padding: 25px" ref="form">
              <span class="commonFont"
                >Are you a State Employee or a Local Public Body (LPB)
                Employee?</span
              >
              <br />
              <br />
              <v-layout justify-end align-content-end>
                <v-btn
                  ref="stateEmpBtn"
                  :color="mainColor"
                  dark
                  @click="
                    displayLPBQuestion = false
                    lpbEmp = false
                  "
                  >State Employee</v-btn
                >
                <v-btn
                  ref="stateEmpBtn"
                  :color="mainColor"
                  dark
                  @click="
                    displayLPBQuestion = false
                    lpbEmp = true
                  "
                  >LPB Employee</v-btn
                >
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown">
          <v-card style="padding: 10px">
            <v-toolbar :color="mainColor" dark>
              <v-card-title class="headline" color="white"
                >Welcome!</v-card-title
              >
            </v-toolbar>
            <v-form style="padding: 10px" ref="form">
              <span class="commonFont"
                >Are you a State Employee or a Local Public Body (LPB)
                Employee?</span
              >
              <br />
              <br />
              <v-layout column>
                <v-btn
                  ref="stateEmpBtn"
                  :color="mainColor"
                  dark
                  @click="
                    displayLPBQuestion = false
                    lpbEmp = false
                  "
                  >State Employee</v-btn
                >

                <v-btn
                  ref="stateEmpBtn"
                  :color="mainColor"
                  dark
                  @click="
                    displayLPBQuestion = false
                    lpbEmp = true
                  "
                  >LPB Employee</v-btn
                >
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <div v-else-if="!displayLPBQuestion && lpbEmp == false">
      <span v-if="lpbDropDown">
        <v-layout justify-center align-content-center>
          <v-flex :class="$vuetify.breakpoint.mdAndUp ? 'xs8' : 'xs12'">
            <v-card>
              <v-toolbar :color="mainColor" dark>
                <v-card-title
                  v-if="$vuetify.breakpoint.mdAndUp"
                  style="padding: 10px"
                  class="headline"
                  color="white"
                  >Local Public Body &amp; Employee ID</v-card-title
                >
                <v-card-title
                  v-else
                  style="padding: 10px"
                  class="headline"
                  color="white"
                  >LPB &amp; Employee ID</v-card-title
                >
              </v-toolbar>
              <v-form style="padding: 20px" ref="lpbform">
                <v-row>
                  <v-col>
                    <v-select
                      v-model="lpbSelect"
                      :items="lpbItems"
                      item-text="name"
                      item-value="code"
                      label="Select LPB"
                      persistent-hint
                      return-object
                      single-line
                      dense
                      menu-props="auto"
                      :rules="lpbSelectionRules"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="employeeId_Agent_"
                      label="Employee ID"
                      ref="employeeId"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-layout justify-start align-content-start>
                <v-spacer></v-spacer>
                <v-btn
                  ref="submitLPBBtn"
                  :color="mainColor"
                  dark
                  @click="submitLPB"
                  style="margin: 20px"
                  ><span v-if="$vuetify.breakpoint.smAndDown">Continue</span
                  ><span v-else>Continue To Applicant Information</span></v-btn
                >
              </v-layout>
            </v-card></v-flex
          ></v-layout
        > </span
      ><span v-else>
        <v-layout justify-center align-content-center>
          <v-flex xs8 v-if="$vuetify.breakpoint.mdAndUp">
            <v-card>
              <v-toolbar :color="mainColor" dark>
                <v-card-title class="headline" color="white"
                  >Start Application</v-card-title
                >
              </v-toolbar>
              <v-form style="padding: 50px" ref="form">
                <span class="commonFont"
                  >Please enter your employee ID number and last name for
                  verification purposes.</span
                >
                <br />
                <br />
                <br />
                <v-layout justify-center align-content-center>
                  <v-flex xs5>
                    <v-text-field
                      @input="showMessage = false"
                      v-model="employeeId"
                      :rules="employeeIdRules"
                      label="Employee ID"
                    ></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6>
                    <v-text-field
                      @input="showMessage = false"
                      v-model="lastName"
                      :rules="lastNameRules"
                      label="Last Name"
                      v-capitalizeName="lastName"
                      @keyup.enter="enterClicked"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <br />
                <span v-if="showMessage" style="color: red"
                  >The information you have submitted does not match our records
                  on file. Please verify your entries and try again.</span
                >
                <br />
                <br />
                <v-layout justify-start align-content-start>
                  <v-btn
                    :color="mainColor"
                    dark
                    @click="displayLPBQuestion = true"
                    >Back</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn ref="submitBtn" :color="mainColor" dark @click="submit"
                    >Submit</v-btn
                  >
                </v-layout>
              </v-form>
            </v-card>
          </v-flex>
          <v-flex xs12 v-if="$vuetify.breakpoint.smAndDown">
            <v-card style="padding: 10px">
              <v-toolbar :color="mainColor" dark style="padding: 5px">
                <v-card-title class="headline" color="white"
                  >Start Application</v-card-title
                >
              </v-toolbar>
              <v-form style="padding: 10px" ref="form">
                <span class="commonFont"
                  >Please enter your employee ID number and last name for
                  verification purposes.</span
                >
                <br />
                <br />
                <br />
                <v-layout justify-center align-content-center>
                  <v-flex xs11>
                    <v-text-field
                      @input="showMessage = false"
                      v-model="employeeId"
                      :rules="employeeIdRules"
                      label="Employee ID"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-center align-content-center>
                  <v-flex xs11>
                    <v-text-field
                      @input="showMessage = false"
                      v-model="lastName"
                      :rules="lastNameRules"
                      label="Last Name"
                      v-capitalizeName="lastName"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <br />
                <span v-if="showMessage" style="color: red"
                  >The information you have submitted does not match our records
                  on file. Please verify your entries and try again.</span
                >
                <br />
                <br />
                <v-flex xs11>
                  <v-btn
                    :color="mainColor"
                    dark
                    @click="displayLPBQuestion = true"
                    >Back</v-btn
                  > </v-flex
                ><v-flex xs11>
                  <v-btn :color="mainColor" dark @click="submit">Submit</v-btn>
                </v-flex>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </span>
    </div>
    <div v-else>
      <div v-if="$vuetify.breakpoint.smAndDown">
        <div v-if="!showSubmitted">
          <v-flex xs12>
            <v-card style="padding: 10px">
              <v-toolbar color="#00558c" dark>
                <v-card-title class="headline" color="white"
                  >Request Contact</v-card-title
                >
              </v-toolbar>
              <div style="padding: 25px">
                <v-form v-model="valid" ref="form2">
                  <v-container fluid>
                    <v-flex xs12>
                      <span class="commonFont" style="color: #00558c"
                        >Thank you for your interest in applying for coverage.
                        You are one step closer to securing protection to
                        provide for your family’s financial future.<br /><br />
                        Please complete the following information and an Agent
                        will be in contact with you soon.</span
                      >
                    </v-flex>

                    <br />
                    <br />

                    <v-flex xs11>
                      <v-text-field
                        v-model="firstName"
                        :rules="firstNameRules"
                        label="Employee First Name"
                        v-capitalizeName="firstName"
                        ref="employeeName"
                        >></v-text-field
                      >
                    </v-flex>

                    <v-flex xs11>
                      <v-text-field
                        v-model="middleName"
                        label="Employee Middle Name"
                        v-capitalizeName="middleName"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs11>
                      <v-text-field
                        v-model="lastName"
                        :rules="lastNameRules"
                        label="Employee Last Name"
                        v-capitalizeName="lastName"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs11>
                      <v-text-field
                        v-model.trim="homePhone"
                        label="Primary Phone"
                        :rules="phoneRules"
                        ref="empPhone"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs11>
                      <v-text-field
                        v-model.trim="workPhone"
                        label="Work Phone"
                        :rules="phoneRules2"
                        ref="empWrkPhone"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs11>
                      <v-text-field
                        v-model.trim="email"
                        :rules="emailRules"
                        label="E-Mail"
                        ref="empEmail"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs11>
                      <v-btn
                        color="#00558c"
                        @click="displayLPBQuestion = true"
                        dark
                        >Back</v-btn
                      >
                    </v-flex>
                    <v-flex xs11>
                      <v-btn color="#00558c" @click="submit" dark>Submit</v-btn>
                    </v-flex>
                  </v-container>
                </v-form>
              </div>
            </v-card>
          </v-flex>
        </div>
        <div v-else>
          <v-layout justify-center align-content-center>
            <v-card>
              <v-toolbar color="#00558c" dark>
                <v-card-title class="headline" color="white"
                  >Thank You</v-card-title
                >
              </v-toolbar>
              <v-layout
                justify-center
                align-content-center
                style="padding: 25px"
              >
                <v-subheader class="commonFont" style="color: #00558c">
                  Your request for contact has been submitted. An agent will be
                  in contact with you soon.
                  <br /><br />
                </v-subheader>
              </v-layout>
            </v-card>
          </v-layout>
        </div>
      </div>
      <div v-else>
        <div v-if="!showSubmitted">
          <v-layout justify-center align-content-center>
            <v-card>
              <v-toolbar color="#00558c" dark>
                <v-card-title class="headline" color="white"
                  >Request Contact</v-card-title
                >
              </v-toolbar>
              <div style="padding: 25px">
                <v-layout justify-center align-content-center>
                  <v-subheader class="commonFont" style="color: #00558c">
                    <br />Thank you for your interest in applying for coverage.
                    You are one step closer to securing protection to provide
                    for your family’s financial future.<br /><br />Please
                    complete the following information and an Agent will be in
                    contact with you soon.
                  </v-subheader>
                </v-layout>
                <br />
                <br />
                <v-form v-model="valid" ref="form2">
                  <v-container fluid>
                    <v-layout row wrap align-center>
                      <v-flex xs4>
                        <v-text-field
                          v-model="firstName"
                          :rules="firstNameRules"
                          label="First Name"
                          v-capitalizeName="firstName"
                          ref="employeeName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-model="middleName"
                          label="Middle Name"
                          v-capitalizeName="middleName"
                          >></v-text-field
                        >
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          v-model="lastName"
                          :rules="lastNameRules"
                          label="Last Name"
                          v-capitalizeName="lastName"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout row align-start>
                      <v-flex xs3>
                        <v-text-field
                          v-model.trim="homePhone"
                          label="Primary Phone"
                          :rules="phoneRules"
                          ref="empPhone"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs3>
                        <v-text-field
                          v-model.trim="workPhone"
                          label="Work Phone"
                          :rules="phoneRules2"
                          ref="empWrkPhone"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs6>
                        <v-text-field
                          v-model.trim="email"
                          :rules="emailRules"
                          label="E-Mail"
                          ref="empEmail"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <br />
                    <br />
                  </v-container>
                </v-form>
                <br /><br />
                <v-layout justify-start align-content-start>
                  <v-btn color="#00558c" @click="displayLPBQuestion = true" dark
                    >Back</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn color="#00558c" @click="submit" dark>Submit</v-btn>
                </v-layout>
              </div>
            </v-card>
          </v-layout>
        </div>
        <div v-else>
          <v-layout justify-center align-content-center>
            <v-card>
              <v-toolbar color="#00558c" dark>
                <v-card-title class="headline" color="white"
                  >Thank You</v-card-title
                >
              </v-toolbar>
              <v-layout
                justify-center
                align-content-center
                style="padding: 25px"
              >
                <v-subheader class="commonFont" style="color: #00558c">
                  Your request for contact has been submitted. An agent will be
                  in contact with you soon.
                  <br /><br />
                </v-subheader>
              </v-layout>
            </v-card>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '../event-bus'
import { AWS_HTTP } from '../http-common.js'
import { log } from '../http-common.js'

export default {
  name: 'EmployeeVerification',
  props: { mainColor: String, entity: Object, retryVerification: Boolean },
  components: {
    errorDialog: () => import(/* webpackPrefetch: true */ './error-dialog.vue'),
  },

  created() {
    if (this.$store.state.employee.match == true) {
      eventBus.$emit('showDemographics')
    }

    if (this.retryVerification) {
      this.displayLPBQuestion = false
      this.lpbEmp = false
    }
  },
  mounted() {
    // console.log(this.$store.state.employee.match)
    if (
      this.$store.state.lpbAgent &&
      this.$store.state.lpbAgent.AgentNumber &&
      this.$store.state.lpbAgent.AgentNumber != ''
    ) {
      this.displayLPBQuestion = false

      if (
        this.$store.state.lpb &&
        this.$store.state.lpb.lpb_name &&
        this.$store.state.lpb_name != ''
      ) {
        this.$nextTick(() => {
          if (this.$store.state.productsFlag == true)
            eventBus.$emit('showProducts')
          else eventBus.$emit('showDemographics')
        })
      } else {
        this.lpbDropDown = true
        var lastLPB = this.$store.state.lastLPB
        this.$store.commit('clearLPB')

        this.employeeId_Agent_ = this.$store.state.employee.EmployeeId

        this.lpbSelect = {}

        this.waitDialog = true
        AWS_HTTP.get('localpublicbodies')
          .then((response) => {
            // console.log(response)

            this.waitDialog = false

            for (let row of response.data) {
              let lpbItem = row
              lpbItem.name = this.toTitleCase(row.lpb_name)
              lpbItem.lpb_name = lpbItem.name
              this.lpbItems.push(lpbItem)
            }

            this.lpbItems = this.lpbItems.sort(function (a, b) {
              if (a.lpb_name.toLowerCase() > b.lpb_name.toLowerCase()) return 1
              if (b.lpb_name.toLowerCase() > a.lpb_name.toLowerCase()) return -1
              if (a.lpb_name.toLowerCase() == b.lpb_name.toLowerCase()) return 0
            })

            this.lpbSelect = JSON.parse(JSON.stringify(lastLPB))
            // console.log(this.lpbSelect)
          })
          .catch((e) => {
            // console.log(e)

            log(e.toString(), true, 'employee-verification.vue mounted')
            this.error = true
          })
      }
    } else if (this.$store.state.employee.match == true) {
      this.$nextTick(() => {
        if (this.$store.state.productsFlag == true)
          eventBus.$emit('showProducts')
        else eventBus.$emit('showDemographics')
        // console.log('emitted!')
      })
    }
  },
  watch: {
    // lpbSelect() {
    //   this.$store.commit('setLPB', this.lpbSelect)
    // },
  },
  data: () => ({
    displayLPBQuestion: true,
    lpbEmp: false,
    error: false,
    errors: [],
    waitDialog: false,
    employeeId_Agent_: '',
    employeeId_Agent_Rules: [(v) => !!v || "Please enter the employee's ID."],
    employeeId: '',
    employeeIdRules: [
      (v) => !!v || 'Please enter your employee ID.',
      (v) =>
        (v && /^([ADad]\d{4}\d*)|(\d{6}\d*)$/.test(v)) ||
        'Employee ID must be 6 or more digits.',
    ],
    lastName: '',
    lastNameRules: [
      (v) => !!v || 'Please enter your last name.',
      (v) =>
        (v && v.length > 1) ||
        'Last name entered must be at least 2 characters.',
    ],
    lpbSelectionRules: [
      (v) => !!v || 'Please select the applicable local public body.',
      (v) =>
        (v && v.code && v.code != '') ||
        'Please select the applicable local public body.',
    ],
    retryCount: 0,
    showMessage: false,

    showSubmitted: false,
    valid: true,
    name: '',
    nameRules: [
      (v) => !!v || 'Full name is required.',
      (v) => (v && v.length > 2) || 'Name must be more than 2 characters.',
    ],
    firstName: '',
    firstNameRules: [
      (v) => !!v || 'First name is required.',
      (v) => (v && v.length > 1) || 'First name must be at least 2 characters.',
    ],
    middleName: '',
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required.',
      (v) =>
        /^([a-zA-Z0-9_+-]+\.?)+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{1}[a-zA-Z0-9-.]+$/.test(
          v.trim()
        ) || 'E-mail must be valid',
      //v => /.+@.+\.{1}.+/.test(v) || 'E-mail must be valid'
    ],

    homePhone: '',
    workPhone: '',
    phoneRules: [
      (v) => !!v || 'Primary phone number is required.',

      (v) =>
        /^[\d{1}]?[ ]?[.\-( ]?[ ]?\d{3}[ ]?[.\-) ]?[ ]?\d{3}[.\- ]?\d{4}[ ]*$/.test(
          v
        ) || 'Please enter a valid phone number with area code.',
    ],
    phoneRules2: [
      (v) =>
        !v ||
        /^[\d{1}]?[ ]?[.\-( ]?[ ]?\d{3}[ ]?[.\-) ]?[ ]?\d{3}[.\- ]?\d{4}[ ]*$/.test(
          v
        ) ||
        'Please enter a valid phone number with area code.',
    ],

    errorDialog: false,
    lpbDropDown: false,
    lpbItems: [],
    lpbSelect: {},
  }),
  methods: {
    toTitleCase(str) {
      return str.toUpperCase()

      // return str
      //   .replace(/\w\S*/g, function (txt) {
      //     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      //   })
      //   .replace(' Of ', ' of ')
      //   .replace(' The ', ' the ')
      //   .replace('Nm', 'NM')
      //   .replace(' Or ', ' or ')
      //   .replace(' And ', ' and ')
      //   .replace('Emw', 'EMW')
    },
    submitLPB() {
      if (this.$refs.lpbform.validate()) {
        this.$store.commit('setLPB', this.lpbSelect)
        this.$store.commit('setLastLPB', this.lpbSelect)
        this.$store.commit('setEntityDept', '') //this.lpbSelect.code)
        this.$store.commit('setEmployeeId', this.employeeId_Agent_)
        eventBus.$emit('showDemographics')
      }
    },
    enterClicked() {
      // console.log(this.$refs.submitBtn)
      this.submit()
    },
    submit() {
      if (this.lpbEmp) {
        if (this.$refs.form2.validate()) {
          this.waitDialog = true
          AWS_HTTP.get('lpb', {
            params: {
              FirstName: this.firstName,
              LastName: this.lastName,
              MiddleName: this.middleName,
              Email: this.email,
              Phone: this.$options.filters.phone(this.homePhone),
              WorkPhone: this.$options.filters.phone(this.workPhone),
            },
          })
            .then(() => {
              this.waitDialog = false
              this.showSubmitted = true

              // console.log(response)
            })
            .catch((e) => {
              log(e.toString(), true, 'employee-verification.vue submit')
              this.waitDialog = false
              this.error = true
              // console.log(e)
              this.errors.push(e)
            })
        }
      } else {
        if (this.$refs.form.validate()) {
          this.waitDialog = true
          AWS_HTTP.get('employee', {
            params: {
              empId: this.employeeId.toUpperCase(),
              lastName: this.lastName,
            },
          })
            .then((response) => {
              if (response.status == 200) {
                if (response.data.match == true) {
                  // console.log(response.data)
                  if (
                    response.data.AgentNumber &&
                    response.data.AgentNumber != ''
                  ) {
                    this.$store.commit('setLPBAgent', response.data)

                    let entityInfo = {}

                    entityInfo.agentName =
                      response.data.FirstName + ' ' + response.data.LastName
                    entityInfo.agentNumber = response.data.LifeNumber
                    entityInfo.agentNumberAlt = response.data.CancerNumber
                    entityInfo.agentPhone = ''

                    // console.log(entityInfo)

                    this.$store.commit('setEntityInfo', entityInfo)

                    AWS_HTTP.get('localpublicbodies')
                      .then((response) => {
                        // console.log(response)
                        this.waitDialog = false

                        for (let row of response.data) {
                          let lpbItem = row
                          lpbItem.name = this.toTitleCase(row.lpb_name)
                          lpbItem.lpb_name = lpbItem.name
                          this.lpbItems.push(lpbItem)
                        }

                        this.lpbItems = this.lpbItems.sort(function (a, b) {
                          if (
                            a.lpb_name.toLowerCase() > b.lpb_name.toLowerCase()
                          )
                            return 1
                          if (
                            b.lpb_name.toLowerCase() > a.lpb_name.toLowerCase()
                          )
                            return -1
                          if (
                            a.lpb_name.toLowerCase() == b.lpb_name.toLowerCase()
                          )
                            return 0
                        })

                        // console.log(this.lpbItems)

                        this.lpbDropDown = true
                      })
                      .catch((e) => {
                        // console.log(e)

                        log(
                          e.toString(),
                          true,
                          'employee-verification.vue submit'
                        )
                        this.error = true
                      })
                  } else {
                    this.waitDialog = false
                    this.$store.commit('setEmployee', response.data)
                    let entityInfo = this.$store.state.entityInfo
                    entityInfo.entityDept = response.data.Agency
                    this.$store.commit('setEntityInfo', entityInfo)
                    eventBus.$emit('showDemographics')
                  }
                } else {
                  this.waitDialog = false

                  this.retryCount++
                  if (this.retryCount == 2)
                    eventBus.$emit('showAltDemographics')
                  else this.showMessage = true
                }
              } else {
                this.waitDialog = false
                this.error = true
              }
            })
            .catch((e) => {
              log(e.toString(), true, 'employee-verification.vue submit')
              this.waitDialog = false
              // console.log(e)
              this.errors.push(e)
              this.error = true
            })
        }
      }
    },
  },
}
</script>
<style>
</style>